// import add from '@/assets/overview/add.png';
// import build from '@/assets/overview/build.png';
// import create from '@/assets/overview/create.png';
// import debugging from '@/assets/overview/debugging.png';
// import download from '@/assets/overview/download.png';
// import release from '@/assets/overview/release.png';
// import submit from '@/assets/overview/submit.png';
// import disabled1 from '@/assets/overview/disabled1.svg';
// import disabled2 from '@/assets/overview/disabled2.svg';
import $i18n from '@/i18n';
import { getImages } from '@/utils/theme';

const images = getImages();

export const stepConfig = [
  {
    key: '01',
    title: $i18n.get({ id: 'aopf.pages.overview.Create.Miniapp', dm: '创建应用' }),
    // imgUrlAdmin: create,
    // imgUrlDeveloper: disabled1,
    imgUrlAdmin: images.homeStep01,
    style: { position: 'relative', top: 0, left: '-5px' },
  },
  {
    key: '02',
    title: $i18n.get({ id: 'aopf.pages.overview.Add.Members', dm: '添加成员' }),
    // imgUrlAdmin: add,
    // imgUrlDeveloper: disabled2,
    imgUrlAdmin: images.homeStep02,
    style: { position: 'relative', top: 0, left: '-20px' },
  },
  {
    key: '03',
    title: $i18n.get({ id: 'aopf.pages.overview.Download.IDE', dm: '下载IDE' }),
    // imgUrlAdmin: download,
    // imgUrlDeveloper: download,
    imgUrlAdmin: images.homeStep03,
    style: { position: 'relative', top: 0, left: '-20px' },
  },
  {
    key: '04',
    title: $i18n.get({ id: 'aopf.pages.overview.Debugging', dm: '开发调试' }),
    // imgUrlAdmin: debugging,
    // imgUrlDeveloper: debugging,
    imgUrlAdmin: images.homeStep04,
    style: { position: 'relative', top: 0, left: '-20px' },
  },
  {
    key: '05',
    title: $i18n.get({ id: 'aopf.pages.overview.Build.New.Version', dm: '构建' }),
    // imgUrlAdmin: build,
    // imgUrlDeveloper: build,
    imgUrlAdmin: images.homeStep05,
    style: { position: 'relative', top: 0, left: '-5px' },
  },
  {
    key: '06',
    title: $i18n.get({ id: 'aopf.pages.overview.Choose.Channel', dm: '选择渠道' }),
    // imgUrlAdmin: submit,
    // imgUrlDeveloper: submit,
    imgUrlAdmin: images.homeStep06,
    style: { position: 'relative', top: 0, left: '-5px' },
  },
  {
    key: '07',
    title: $i18n.get({ id: 'aopf.pages.overview.Release', dm: '正式发布' }),
    // imgUrlAdmin: release,
    // imgUrlDeveloper: release,
    imgUrlAdmin: images.homeStep07,
    style: { position: 'relative', top: 0, left: '-20px', height: '90px' },
  },
];
